import { logger } from './logger';

/**
 * Error logging utility for the application
 * Provides centralized error logging and can be extended to send errors to an external service
 */

// In a real app, this would likely send errors to a monitoring service like Sentry, LogRocket, etc.
export const logError = (error, context = {}) => {
  const errorInfo = {
    message: error?.message || 'Unknown error',
    stack: error?.stack,
    timestamp: new Date().toISOString(),
    ...context
  };
  
  logger.error('Application error:', errorInfo);

  // Example of how this could be extended to log to a service
  // if (process.env.NODE_ENV === 'production') {
  //   sendErrorToMonitoringService(errorDetails);
  // }
  
  return errorInfo;
};

// Generic error handler that can be used with ErrorBoundary onError prop
export const errorHandler = (error, info, componentName = 'Component') => {
  logError(error, { 
    componentName, 
    componentStack: info?.componentStack 
  });
};

// Function to create a customized onError handler for a specific component
export const createErrorHandler = (componentName) => {
  return (error, info) => errorHandler(error, info, componentName);
};

// Mock implementation of sending to a monitoring service
// In a real app, this would use an actual API call
// eslint-disable-next-line no-unused-vars
const sendErrorToMonitoringService = (errorDetails) => {
  // This is just a placeholder for demonstration
  // In a real app, you'd use something like:
  // Sentry.captureException(error, { extra: errorDetails });
};
